import { module } from 'angular';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { SharedFiltersModule } from './filters/shared-filters.module';
import { SharedComponentsModule } from './components/shared-components.module';

export const SharedModule = module('app.shared', [
  SharedComponentsModule.name,
  SharedDirectivesModule.name,
  SharedFiltersModule.name
]).name;



// WEBPACK FOOTER //
// ./app/shared/shared.module.ts